import React from 'react';
import { LinkedinIcon, XingIcon, SocialIcon, IndeedSquareIcon } from '../Icons/AryaIcons';
import LinkedInGreyIcon from '../Icons/LinkedInGrey';

export default function getSourceSvg(sourceName, props = {}) {
  let icon;
  switch (sourceName) {
    case 'linkedin':
      icon = <LinkedinIcon {...props} />;
      break;
    case 'grey-linkedin':
      icon = <LinkedInGreyIcon {...props} />;
      break;
    case 'xing':
      icon = <XingIcon {...props} />;
      break;
    case 'indeed-small':
      icon = <IndeedSquareIcon {...props} />;
      break;
    default:
      icon = <SocialIcon {...props} />;
  }

  return icon;
}
